import { render } from "./GDProjectComponent.vue?vue&type=template&id=3e69c45a&scoped=true"
import script from "./GDProjectComponent.vue?vue&type=script&lang=js"
export * from "./GDProjectComponent.vue?vue&type=script&lang=js"

import "./GDProjectComponent.vue?vue&type=style&index=0&id=3e69c45a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e69c45a"]])

export default __exports__